export enum TOOLTIP_TYPE {
    bottom = 'bottom',
    top = 'top',
    left = 'left',
    rightBottom = 'right-bottom',
    leftBottom = 'left-bottom',
    right = 'right',
    title = 'title',
}
